import cookie from './cookie';

/*
 * 分析
 */
const parser = function(raw){
    const result = {};
    if(!raw) return result;

    const list = raw.split('&');
    list.map(function(current){
        const arr = current.split('=');
        const key = arr[0];

        let value = arr[1];
        result[key] = value;
    });

    return result;
}

//分析xman_us_f中x_user的信息
const analysisUser = function(raw){
    //替换掉用户信息中可能存在的<>
    raw = (raw || '').replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const list = raw.split('|');
    return {
        country: list[0],
        lastName: list[1],
        firstName: list[2],
        serviceType: list[3],
        memberSeq: list[4]
    };
};

//分析xman的数据
const analysisXman = function(){
    const raw = cookie.get('xman_us_f') || '';
    const result = parser(raw);

    result.x_user = analysisUser(result.x_user);
    /*
    const list = raw.split('&');
    list.map(function(current){
        const arr = current.split('=');
        const key = arr[0];

        let value = arr[1];
        if(key === 'x_user'){
            value = analysisUser(value) || {};
        };

        result[key] = value;
    });
    */

    return result;
}

//获取beacon id
const getBeaconId = function(){
    return cookie.get('ali_beacon_id')
}

//获取cna的值
const getCna = function(){
    return cookie.get('cna');
}

//判断用户是否登录
const getIsLoggedIn = function(){
    const value = cookie.get('xman_us_t');
    return value && value.indexOf('sign=y') !== -1;
};

//获取用户的id
const getUserId = function(){
    return (cookie.get('ali_apache_track') || '')
        .replace(/.+mid=(.+)$/, '$1')
        .replace(/"/g, '');
};

//用户是否第一次登录
const getIsFirstIn = function(){
    return cookie.get('ali_intl_firstIn') === '';
};

//获取本地语言
const getLanguage = function(){
    const value = cookie.get('intl_locale');
    return value || analysisXman().x_locale || 'en_US';
};

//获取用户信息, 可以通过这个获取用户的完全信息
const getUser = function(){
    return analysisXman().x_user;
};

//是否海外用户
const  getIsOversea = function(){
    return analysisXman().x_l == '0';
};

//是否有新用户
const getIsNewUser = function(){
    return analysisXman().x_user.memberSeq !== '';
};

// 服务器地域
const getServerDomain = function(){
    const hzServiceType = ['gs', 'cgs', 'twgs', 'hkgs', 'cnfm'];
    const userType = analysisXman().x_user.serviceType;
    return hzServiceType.indexOf(userType) > -1 ? 'hz' : 'us';
};

//获取ctoken
const getCToken = function(){
    const value = cookie.get('xman_us_t') || '';
    const list = parser(value);
    return list.ctoken || '';
}

export default {
    //核心方法
    core: cookie,
    //获取beaconId
    getBeaconId: getBeaconId,
    //获取CNA
    getCna: getCna,
    //判断用户是否登录
    getIsLoggedIn: getIsLoggedIn,
    //获取用户的id
    getUserId: getUserId,
    //用户是否第一次登录
    getIsFirstIn: getIsFirstIn,
    //获取本地语言
    getLanguage: getLanguage,
    //获取用户信息, 可以通过这个获取用户的完全信息
    getUser: getUser,
    //是否海外用户
    getIsOversea: getIsOversea,
    //是否有新用户
    getIsNewUser: getIsNewUser,
    //服务器地域
    getServerDomain: getServerDomain,
    //获取CToken
    getCToken: getCToken
};

/*
 // 是否登录
let isLoggedIn = false,
 // 是否是新用户
_isNewUser = false,
// 是否第一次登录
isFirstIn = true,
// 当前登录用户注册时所在的国家
country = '',

firstName = '',
lastName = '',
serviceType = '',
memberSeq = '',
userId = '',
// 页面显示语言，默认en_US。这个会决定webuser.getLocal().
locale = '';



let setup = function() {
    let usfCookieMap = {};
    if (cookie.get('xman_us_f')) {
        let usfCookieArr = cookie.get('xman_us_f').split('&');
        for (let i = usfCookieArr.length; i--;) {
            let tempCookieArr = usfCookieArr[i].split('=');
            usfCookieMap[tempCookieArr[0]] = tempCookieArr[1];
        }
    }
    let isLoginCookie = cookie.get('xman_us_t');
    let userCookie = cookie.get('xman_us_f');
    let userReg = /x_user=([^&"]+)/;

    // 是否登录
    if (isLoginCookie && isLoginCookie.indexOf('sign=y') !== -1) {
        isLoggedIn = true;
    } else {
        isLoggedIn = false;
    }

    // 获得用户基本信息，曾经登录过并且在cookie中有用户信息。
    if (userCookie && userReg.test(userCookie)) {
        userCookie.match(userReg);
        userCookie = RegExp.$1;
        userCookie = userCookie.split('|');

        if (userCookie.length >= 5) {
            country = userCookie[0];
            firstName = userCookie[1].replace(/</g, "&lt;").replace(/>/g, "&gt;");
            lastName = userCookie[2].replace(/</g, "&lt;").replace(/>/g, "&gt;");
            serviceType = userCookie[3];
            memberSeq = userCookie[4];
        }
    }

    // 是否是新用户
    if (memberSeq !== '') {
        _isNewUser = true;
    }

    // 是否是第一次登录
    if (cookie.get('ali_intl_firstIn') === '') {
        isFirstIn = true;
    }

    // 获取当前语言。
    if (cookie.get('intl_locale')) {
        locale = cookie.get('intl_locale');
    } else {
        // 针对AE国家分站,使用新的key,判断用户是哪个站点
        let xLocale = usfCookieMap['x_locale'];
        if (xLocale) {
            locale = xLocale;
        } else {
            locale = 'en_US';
        }

    }

    return this;
};

// 立即初始化
setup();


let getIsOversea = function() {
    let isOversea = true;
    let userCookie = cookie.get('xman_us_f');

    // 国内
    if (userCookie && userCookie.indexOf('x_l=1') !== -1) {
        isOversea = false;
    }

    // 国外
    if (userCookie && userCookie.indexOf('x_l=0') !== -1) {
        isOversea = true;
    }

    return isOversea;
};

let isNewUser = () => {
    // 根据memberseq是否存在来判断是否是新用户
    let result = true;
    if (memberSeq !== '') {
        _isNewUser = false;
        result = false;
    }
    return result;
}


export default {
    isLoggedIn: isLoggedIn,
    isNewUser: isNewUser(),
    isFirstIn: isFirstIn,
    country: country,
    firstName: firstName,
    lastName: lastName,
    serviceType: serviceType,
    memberSeq: memberSeq,
    locale: locale,

    getUserId(){

    },

    // 服务器地域
    serverDomain() {
        let hzServiceType;
        setup();
        hzServiceType = ['gs', 'cgs', 'twgs', 'hkgs', 'cnfm'];
        if (hzServiceType.indexOf(serviceType) > -1) {
            return 'hz';
        }
        return 'us';
    },
    getIsLoggedIn() {
        setup();
        return isLoggedIn;
    },
    getIsNewUser() {
        setup();
        return isNewUser();
    },
    getCountry() {
        setup();
        return country;
    },
    getFirstName() {
        setup();
        return firstName;
    },
    getLastName() {
        setup();
        return lastName;
    },
    getServiceType() {
        setup();
        return serviceType;
    },
    getMemberSeq() {
        setup();
        return memberSeq;
    },
    getLanguage() {
        setup();
        return locale;
    },
    getIsOversea: getIsOversea
};
*/



// WEBPACK FOOTER //
// ./node_modules/@alife/mscc-cookie/src/cookie-info.js